
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import { Route, Switch } from 'react-router-dom'

import './App.css'
import i18n from './i18n'
import * as actions from './actionTypes'
import {REFRESH_TTL} from './constants'
import DcpMenu from './components/menu/Menu'
import SessionSupervisor from './components/counseling-session/SessionSupervisor'
import ProtectedRoute from './components/routes/ProtectedRoute'
import LoginContainer from './components/login/LoginContainer'
import SetupContainer from './components/setup/SetupContainer'
import CounselingSessionContainer from './components/counseling-session/CounselingSessionContainer'
import {getPathnameEnding} from './utils'
import {ErrorNotice401, ErrorNotice404, ErrorNotice500} from './components/error-notices/notices'


const styles = theme => ({
  appRoot: {
    backgroundColor: '#f5f5f5',
    color: '#707070',
    display: 'flex',
    minHeight: '100vh'
  },
  appVersion: {
    fontSize: '.65rem',
    padding: '0 0 10px 10px',
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  'w-100': {
    width: '100%'
  }
})

class App extends Component {
  constructor(props) {
    super(props)
    this.initLanguage()
  }

  initLanguage() {
    i18n.on('initialized', () => {
      this.props.applyLanguage(i18n.language)
    })
  }

  render() {
    const {classes, isSessionVerified, location: {pathname}, theme} = this.props
    return (
      <div className={classes.appRoot}>
        <SessionSupervisor refreshTTL={REFRESH_TTL}/>
        <CssBaseline/>
        <MuiThemeProvider theme={createMuiTheme(theme)}>
          {/* don't render until we confirm session status */}
          {isSessionVerified && (
            <Grid container direction="column">
              <Grid item xs="auto" className={classes['w-100']}>
                <DcpMenu/>
              </Grid>
              <Grid container item justify="center" xs>
                <Grid container direction="column" item sm={10} xs>
                  <Grid container item justify="center" xs>
                    <Grid className={getPathnameEnding(pathname)} id="route-wrapper" item xs>
                      {this.renderRoutes()}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <span style={{display:"none"}}>
                {process.env.REACT_APP_VERSION}
              </span>
            </Grid>
          )}
        </MuiThemeProvider>
      </div>
    )
  }

  renderRoutes() {
    const {isAuthorized} = this.props
    return (
      <Switch>
        <Route
          component={LoginContainer}
          id="login"
          exact
          path="/login"
        />
        <ProtectedRoute
          component={SetupContainer}
          exact
          grantAccess={isAuthorized}
          path="/"
          redirectPath="/login"
        />
        <ProtectedRoute
          component={CounselingSessionContainer}
          grantAccess={isAuthorized}
          path="/session"
          redirectPath="/login"
        />
        {/* Error Pages */}
        <Route
          component={ErrorNotice401}
          path="/notice/401"
        />
        <Route
          component={ErrorNotice500}
          path="/notice/500"
        />
        <Route component={ErrorNotice404}/>
      </Switch>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  applyLanguage(lang) {
    const action = {type: actions.APPLY_LANGUAGE, payload: {lang}}
    dispatch(action)
  },
  checkSessionStatus() {
    const action = {type: actions.CHECK_SESSION_STATUS}
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  isAuthorized: state.authorization.isAuthorized,
  isSessionVerified: state.authorization.isSessionVerified,
  theme: state.globalSettings.theme
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(App)


// WEBPACK FOOTER //
// ./src/App.js